import axios from "axios";
import { getBaseUrlParams } from "../../utils/getBaseUrlParams";
import { queryParams } from "../../utils/queryParams";

const { short_url } = getBaseUrlParams();

const aiDynamicApi = axios.create({ baseURL: queryParams.apiVersion + "" });

const PAGE_BASE = `pages/ai/chat_agent`;
const WIDGET_BASE = `pages/ai/pages`;

const path = (pageName, path) =>
  pageName ? `${WIDGET_BASE}/${pageName}${path}` : `${PAGE_BASE}${path}`;

export const aiApi = {
  getSessionId(pageName, filter) {
    const url = path(pageName, "/new");
    return aiDynamicApi.get(url, { params: { short_url, ...filter } });
  },

  getChatHistory(id) {
    const url = path(null, `/${id}`);
    return aiDynamicApi.get(url, { params: { short_url } });
  },

  getConversation(pageName) {
    const url = path(pageName, "");
    return aiDynamicApi.get(url, { params: { short_url } });
  },

  sendPrompt(params, pageName) {
    const url = path(pageName, "");
    return aiDynamicApi.post(url, { short_url, ...params });
  },

  sendFeedback(id, params, pageName) {
    const url = path(pageName, `/${id}`);
    return aiDynamicApi.put(url, { short_url, ...params });
  }
};
